import { render, staticRenderFns } from "./ActionDocumentsItem.vue?vue&type=template&id=37b72d22&scoped=true"
import script from "./ActionDocumentsItem.vue?vue&type=script&lang=ts"
export * from "./ActionDocumentsItem.vue?vue&type=script&lang=ts"
import style0 from "./ActionDocumentsItem.vue?vue&type=style&index=0&id=37b72d22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b72d22",
  null
  
)

export default component.exports